var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3243_80154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12H3V13.3H12.3V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 6.7H9.7V10.7H5.7V6.7H3L7.7 2L12.3 6.7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3243_80154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.3,
    height: 11.3,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadExcel);
export default __webpack_public_path__ + "static/media/upload-excel.6642722bf98e5fd818e76ca5c4ab7b80.svg";
export { ForwardRef as ReactComponent };